
function Challenge() {
  return (
    <section className="py-16 md:py-24 lg:py-32 border-bx border-gray-300">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">
          <div className="lg:col-span-5">
            <h2 className="mb-8 md:mb-12 text-3xl md:text-4xl lg:text-5xl font-bold">
              The <br /> Challenge
            </h2>
          </div>
          <div className="lg:col-span-7">
            <div className="text mb-12 md:mb-16 lg:mb-24">
              <h5 className="text-lg md:text-xl lg:text-2xl font-normal leading-relaxed md:leading-loose">
                The goal is there are many variations of passages of Lorem Ipsum
                available, but the majority have suffered alteration in some
                form, by injected humour, or randomised words which don&apos;t
                look even slightly believable.
              </h5>
            </div>
            <div className="accordion borderx border-gray-300 rounded-lg mt-16 md:mt-24 lg:mt-32">
              <div className="item active border-bx border-gray-300 first:rounded-t-lg overflow-hidden">
                <button className="title w-full px-6 md:px-8 py-4 md:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <h6 className="text-left text-base md:text-lg font-semibold">Designing Content With AI Power</h6>
                  <span className="ico transform transition-transform duration-300 text-lg md:text-xl">+</span>
                </button>
                <div className="accordion-info px-6 md:px-8 py-4 md:py-6 bg-gray-50">
                  <p className="text-gray-700">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>

              <div className="item border-bx border-gray-300 overflow-hidden">
                <button className="title w-full px-6 md:px-8 py-4 md:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <h6 className="text-left text-base md:text-lg font-semibold">Talented, Professional & Expert Team</h6>
                  <span className="ico transform transition-transform duration-300 text-lg md:text-xl">+</span>
                </button>
                <div className="accordion-info hidden px-6 md:px-8 py-4 md:py-6 bg-gray-50">
                  <p className="text-gray-700">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>

              <div className="item overflow-hidden last:rounded-b-lg">
                <button className="title w-full px-6 md:px-8 py-4 md:py-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <h6 className="text-left text-base md:text-lg font-semibold">We Build and Activate Brands</h6>
                  <span className="ico transform transition-transform duration-300 text-lg md:text-xl">+</span>
                </button>
                <div className="accordion-info hidden px-6 md:px-8 py-4 md:py-6 bg-gray-50">
                  <p className="text-gray-700">
                    Taken possession of my entire soul, like these sweet
                    mornings of spring which i enjoy with my whole.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Challenge;
